<template>
  <div>
    <div class="contents game-info">
      <b-table-simple responsive table-class="table-sm">
        <b-tbody>
          <b-tr>
            <b-th sticky-column>
              {{ $t("title.admin.game_no") }}
            </b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'1_' + idx">
              {{ player.gameno }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.player_no") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'2_' + idx">
              {{ player.gameplayerno }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.member_no") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'3_' + idx">
              {{ player.playerno }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.common.name") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'4_' + idx">
              {{ player.playername }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.common.nickname") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'5_' + idx">
              <MemberInfo
                :nickname="player.playernickname"
                :playerno="player.playerno"
                :no_img="true"
              />
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.common.gender") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'6_' + idx">
              {{ player.gender | gender }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.teebox") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'7_' + idx">
              {{ player.teebox | teeboxType }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.mulligan") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'8_' + idx">
              {{ player.mulliganflag }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.common.level") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'9_' + idx">
              {{ player.gamelevel | levelType }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.pph") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'10_' + idx">
              {{ player.avgput | toFixed }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.gir") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'11_' + idx">
              {{ player.greenrate || "-" }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.avg_distance") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'12_' + idx">
              {{ player.avgdistance | toFixed }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.max_distance") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'13_' + idx">
              {{ player.maxdistance | toFixed }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.fareway_hit") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'14_' + idx">
              {{ player.farewayrate | toFixed }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.par_save_rate") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'15_' + idx">
              {{ player.parsave | toFixed }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.holeinone") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'16_' + idx">
              {{ player.holeinone }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.albatross") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'17_' + idx">
              {{ player.albatross }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.eagle") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'18_' + idx">
              {{ player.eagle }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.birdie") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'19_' + idx">
              {{ player.birdie }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.par") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'20_' + idx">
              {{ player.par }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.completed_hole") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'21_' + idx">
              {{ player.holedone }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.start_time") }}</b-th>
            <b-td
              v-for="(player, idx) in playerlist"
              :key="'22_' + idx"
              class="text-date"
            >
              {{ player.timezone_regdate | dateformat }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.closed") }}</b-th>
            <b-td
              v-for="(player, idx) in playerlist"
              :key="'23_' + idx"
              class="text-date"
            >
              {{ player.timezone_enddate | dateformat }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.common.location") }}</b-th>
            <b-td
              v-for="(player, idx) in playerlist"
              :key="'24_' + idx"
              class="shop-name"
            >
              {{ player.shopname }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.common.course") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'25_' + idx">
              {{ player.coursename }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th sticky-column>{{ $t("title.admin.golfcourse_code") }}</b-th>
            <b-td v-for="(player, idx) in playerlist" :key="'26_' + idx">
              {{ player.coursecode }}
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          :aria-label="$t('button.common.list')"
          @click="
            $router.push({
              name: 'GameDataView',
              query: {
                /*gameno: gameno,
                startdate: startdate,
                starttime: starttime,
                enddate: enddate,
                endtime: endtime,*/
              },
            })
          "
          >{{ $t("button.common.list") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/gamedata";

export default {
  name: "GameDataInfo",
  data() {
    return {
      gameno: this.$route.query.gameno,
      startdate: this.$route.query.startdate,
      starttime: this.$route.query.starttime,
      enddate: this.$route.query.enddate,
      endtime: this.$route.query.endtime,
      playerlist: [],
      view_hide: null,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      ax.gameInfo(this.gameno, (data) => {
        if (data) {
          this.playerlist = data.playerlist;
        } else {
          this.playerlist = [];
        }
      });
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
